"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseEnrollment = void 0;
var CourseEnrollment;
(function (CourseEnrollment) {
    let PendingAction;
    (function (PendingAction) {
        PendingAction["enroll"] = "enroll";
        PendingAction["conclude"] = "conclude";
        PendingAction["activate"] = "activate";
        PendingAction["deactivate"] = "deactivate";
    })(PendingAction = CourseEnrollment.PendingAction || (CourseEnrollment.PendingAction = {}));
})(CourseEnrollment = exports.CourseEnrollment || (exports.CourseEnrollment = {}));
//# sourceMappingURL=courseEnrollment.js.map